/**
 * 逻辑流编辑器 - 可拖拽节点包装组件
 * 从 React Flow 示例提取，适配项目暗色主题
 */

import React, {type DragEvent, useCallback} from 'react';
import type {LogicFlowNodeType} from '../../../types/logicFlow';

interface Props {
    type: LogicFlowNodeType;
    children: React.ReactNode;
    onAddNode: (type: LogicFlowNodeType) => void;
    disabled?: boolean;
}

const Draggable: React.FC<Props> = ({type, children, onAddNode, disabled}) => {
    const onDragStart = useCallback(
        (event: DragEvent<HTMLDivElement>, data: { type: LogicFlowNodeType }) => {
            if (disabled) {
                event.preventDefault();
                return;
            }
            event.dataTransfer.setData('application/logicflow-nodetype', data.type);
            event.dataTransfer.effectAllowed = 'move';
        },
        [disabled]
    );

    const onClick = useCallback(() => {
        if (disabled) {
            return;
        }
        onAddNode(type);
    }, [type, onAddNode, disabled]);

    return (
        <div
            draggable={!disabled}
            onDragStart={(e) => onDragStart(e, {type})}
            onClick={onClick}
            style={{cursor: disabled ? 'not-allowed' : 'grab'}}
        >
            {children}
        </div>
    );
};

export {Draggable};
export type {Props as DraggableProps};
